import React from 'react';
import { Row, Column } from 'react-foundation';
//TODO convert to universal component
const Inputs = (props) => {
	if (props.inputType === 'first_name') {
		return (
			<div className="input-wrapper string required user_first_name">
				<label className="string required" htmlFor="user_first_name">
					First name
				</label>
				<input
					className="string required"
					type="text"
					autoFocus="autofocus"
					name="user[first_name]"
					id="user_first_name"
				/>
			</div>
		);
	}

	if (props.inputType === 'last_name') {
		return (
			<div className="input-wrapper string required user_last_name">
				<label className="string required" htmlFor="user_last_name">
					Last name
				</label>
				<input
					className="string required"
					type="text"
					name="user[last_name]"
					id="user_last_name"
				/>
			</div>
		);
	}

	if (props.inputType === 'email') {
		return (
			<div className="input-wrapper email required user_emai">
				<label className="email required" htmlFor="user_email">
					Email address
				</label>
				<input
					type="email"
					className="string email required"
					name="user[email]"
					id="user_email"
				/>
			</div>
		);
	}

	if (props.inputType === 'phone_number') {
		return (
			<div className="input-wrapper tel ooptional user_phone_number">
				<label className="tel optional" htmlFor="user_phone_number">
					Phone number
				</label>
				<input
					type="tel"
					className="string tedl optional"
					name="user[phone_ner]"
					id="userne_number"
				/>
			</div>
		);
	}

	if (props.inputType === 'linked_in_profile') {
		return (
			<div className="input-wrapper string optional user_linked_in_profile">
				<label
					className="string optional"
					htmlFor="user_linked_in_profile"
				>
					LinkedIn profile
				</label>
				<input
					type="text"
					className="string optional"
					placeholder="Should start with http, https or www"
					name="user[linked_in_profile]"
					id="user_linked_in_profile"
				/>
			</div>
		);
	}

	if (props.inputType === 'organization_relationship') {
		return (
			<div className="input-wrapper select optional user_organization_relationship">
				<label
					className="string optional group-label"
					htmlFor="user_interest_areas"
				>
					What is your relationship with the organization
				</label>
				<select
					className="select optional"
					placeholder="Select an option"
					name="user[organization_relationship]"
					id="user_organization_relationship"
				>
					<option value></option>
					<option value="Staff">Staff</option>
					<option value="Volunteer">Volunteer</option>
				</select>
			</div>
		);
	}

	if (props.inputType === 'title') {
		return (
			<div className="input-wrapper string optional user_title">
				<label className="string optional" htmlFor="user_title">
					What is your role or title in the company?
				</label>
				<input
					className="string optional"
					placeholder="Select an option"
					type="text"
					name="user[title]"
					id="user_title"
				/>
			</div>
		);
	}

	if (props.inputType === 'current_password') {
		return (
			<div className="input-wrapper password optional user_current_passerword">
				<label
					className="password optional"
					htmlFor="user_current_password"
				>
					Current password
				</label>
				<input
					className="password optional"
					placeholder="You must enter your current password to change it."
					type="password"
					name="user[current_password]"
					id="user_curent_password"
				/>
			</div>
		);
	}

	if (props.inputType === 'password_confirmation') {
		return (
			<div className="input-wrapper password optional user_password_confirmation">
				<label
					className="password optional"
					htmlFor="user_password_confirmation"
				>
					New password confirmation
				</label>
				<input
					className="password optional"
					type="password"
					name="user[password_confirmation"
					id="user_password_confirmation"
				/>
			</div>
		);
	}

	if (props.inputType === 'password') {
		return (
			<div className="input-wrapper password optional user_password">
				<label className="password optional" htmlFor="user_password">
					New password
				</label>
				<input
					className="password optional"
					type="password"
					name="user[password]"
					id="user_password"
				></input>
			</div>
		);
	}

	if (props.inputType === 'has_organization') {
		return (
			<>
				<label style={{ paddingBottom: '0.5rem' }}>
					{' '}
					Are you representing an organization?{' '}
				</label>
				<div className="grid-x grid-padding-x">
					<fieldset
						className="small-6 cell"
						style={{ padding: 0, verticalAlign: 'center' }}
					>
						<input
							type="hidden"
							name="user[organization_link]"
							value
						/>
						<input
							type="radio"
							name="user[organization_link]"
							id="user_organization_link_yes"
							onChange={props.toggle_organization}
						/>
						<label
							className="collection_radio_buttons"
							htmlFor="user_organization_link_yes"
						>
							Yes
						</label>
						<input
							type="radio"
							value="0"
							name="user[organization_link]"
							id="user_organization_link_0"
						/>
						<label
							className="collection_radio_buttons"
							htmlFor="user_organization_link_0"
						>
							No
						</label>
					</fieldset>
				</div>
			</>
		);
	}

	if (props.inputType === 'organization_name') {
		return (
			<>
				<label style={{ paddingBottom: '0.5rem' }}>
					{' '}
					Find your organization from our database. If the
					organization is not in the directory choose "new
					organization"{' '}
				</label>
				<div className="grid-x grid-padding-x">
					<fieldset
						className="small-8 cell"
						style={{ padding: 0, verticalAlign: 'center' }}
					>
						<input
							type="hidden"
							name="user[organization_link]"
							value
						/>
						<Column small={8} style={{ paddingLeft: 0 }}>
							<input
								label="Enter the organization you are affiliated to"
								placeholder="Start typing to find an existing organization"
								data-autocomplete="/organizations/autocomplete_organization_name"
								type="text"
								name="user[organization]"
								id="user_organization"
								className="ui-autocomplete-input"
							/>
						</Column>
						<Column small={4} style={{ paddingTop: '0.5rem' }}>
							<input
								type="radio"
								value="9876543"
								name="user[organization]"
								id="user_organization_9876543"
							/>
							<label
								className="collection_radio_buttons"
								htmlFor="user_organization_9876543"
							>
								New organization
							</label>
						</Column>
					</fieldset>
				</div>
			</>
		);
	}

	if (props.inputType === 'user_interest_areas') {
		return (
			<div className="form-group interest-areas-container">
				<label
					className="string required group-label"
					htmlFor="user_interest_areas"
				>
					Please tell what topics you are most interested in. We will
					customize the content you see
				</label>
				<div className="row check_boxes" id="interest_area_checkboxes">
					<div className="columns small-12 button-group">
						<input
							type="hidden"
							name="user[interest_Area_ids][]"
							value
						/>
						{props.interest_areas.map((interestObject, index) => {
							const id =
								'user_interest_area_ids_' + interestObject.id;

							return (
								<span key={id}>
									<label htmlFor={id}>
										<input
											type="checkbox"
											value={index + 1}
											name="user[interst_area_ids][]"
											id={id}
										/>
										<label
											className="collection_check_boxes"
											htmlFor={id}
										>
											{interestObject.name}
										</label>
									</label>
								</span>
							);
						})}
						<span>
							<label htmlFor="user_interest_areaa_ids_1"></label>
						</span>
					</div>
				</div>
			</div>
		);
	}

	if (props.inputType === 'user_profile_image') {
		return (
			<>
				<label
					className="string optional"
					htmlFor="user_backup_profile_image"
				>
					Some profile pictures to choose from
				</label>

				<div className="row backup-profile-image-container">
					<div className="columns small-12 button-group">
						<input
							type="hidden"
							name="user[backup_profile_image"
							value
						/>
						{props.backup_profile_images.map((imageArr) => {
							const id =
								'user_backup_profile_image_toyfaces_colored_bg' +
								imageArr[0].slice(19, 27);

							return (
								<span key={id}>
									<label htmlFor={id}>
										<input
											type="radio"
											value={imageArr[0]}
											name="user[backup_profile_image]"
											id={id}
										/>
										<label htmlFor={id}>
											<img
												width={props.imageSize}
												height={props.imageSize}
												src={imageArr[1]}
											/>
										</label>
									</label>
								</span>
							);
						})}
					</div>
				</div>

				<div className="input-wrapper attachinary optional user_profile_image">
					<label
						className="attachinary optional"
						htmlFor="user_profile_image"
					>
						Or upload your own
					</label>
					<input
						className="attachinary optional attachinary-input"
						data-attachinary='{"accessible":true,"single":true,"scope":"profile_image","maximum":1,"singular":"profile_image","plural":"profile_images","files":[]}'
						data-form-data='{"callback":"http://localhost:3000/attachinary/cors","tags":"development_env,attachinary_tmp","timestamp":1625065590,"signature":"48d0574101831c09254aecdd626165a3c3c97da5","api_key":969568747197145}'
						data-url="https://api.cloudinary.com/v1_1/sponsor-circle/auto/upload"
						type="file"
						name="user[profile_image]"
						id="user_profile_image"
					/>
					<div
						className="attachinary_container"
						style={{ display: 'none' }}
					>
						<input type="hidden" name="user[profile_image]" value />
					</div>
				</div>
			</>
		);
	} else {
		return <></>;
	}
};

export default Inputs;
